import { Box, Card, CardContent, CircularProgress, Grid, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Page from 'src/components/Page';
import palette from 'src/theme/palette';
import DashboardListingCard from 'src/sections/dashboard-sections/DashboardListingCard';
import RecentActivities from 'src/sections/dashboard-sections/RecentActivities';
import ListingChart from 'src/sections/dashboard-sections/ListingChart';
import PropertyLeadManagement from 'src/sections/dashboard-sections/PropertyLeadManagemnet';
import PropertyCalendar from 'src/sections/dashboard-sections/PropertyCalender';
import PerformanceChart from 'src/sections/dashboard-sections/PerformanceChart';
import { get_dashboard_listings, get_dashboard_graph, get_performance_chart, get_recent_activity } from '../ApiServices';

export default function DashboardApp() {
  const [selectedDate, setSelectedDate] = useState(new Date());

  // States
  const [listings, setListings] = useState(null);
  const [graph, setGraph] = useState(null);
  const [performance, setPerformance] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState('');
  const [recentActivity, setRecentActivity] = useState(null);
  const [loading, setLoading] = useState(true);
  // States

  const fetchGraphData = async (period = '') => {
    try {
      const graphRes = await get_dashboard_graph(period);
      setGraph(graphRes);
    } catch (error) {
      console.error('Graph API Error:', error);
    }
  };

  // Data fetching
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const [listingsRes, performanceRes, recentActivity] = await Promise.all([
          get_dashboard_listings(),
          get_performance_chart(),
          get_recent_activity()
        ]);

        setListings(listingsRes);
        setPerformance(performanceRes);
        setRecentActivity(recentActivity);

        await fetchGraphData('');
      } catch (error) {
        console.error('Dashboard API Error:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  const handlePeriodChange = (period) => {
    setSelectedPeriod(period);
    fetchGraphData(period);
  };

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
  };

  return (
    <Page title={`Dashboard | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Typography
        sx={{
          fontSize: { xs: 20, md: 25 },
          fontFamily: 'poppinsSemiBold',
          color: palette.primary.titledark,
          mb: 3,
          mt: 5,
          pb: 1,
          pl: 4
        }}
      >
        Dashboard
      </Typography>

      <Box>
        <DashboardListingCard listings={listings} />
      </Box>

      <Grid container spacing={3} sx={{ px: 4, pl: 3 }}>
        <Grid item xs={12} md={6}>
          <RecentActivities recentActivity={recentActivity}/>
        </Grid>
        <Grid item xs={12} md={6}>
          <ListingChart graph={graph} onPeriodChange={handlePeriodChange} />
        </Grid>
      </Grid>

      {/* <Grid container spacing={3} sx={{ px: 4, pl: 3, mt: 3 }}>
        <Grid item xs={12} md={6}>
          <PropertyLeadManagement selectedDate={selectedDate} />
        </Grid>
        <Grid item xs={12} md={6}>
          <PropertyCalendar selectedDate={selectedDate} onDateChange={handleDateChange} />
        </Grid>
      </Grid> */}

      <Grid container spacing={3} sx={{ px: 4, pl: 3, mt: 3 }}>
        <Grid item xs={12} md={12}>
          <PerformanceChart performance={performance} />
        </Grid>
      </Grid>
    </Page>
  );
}
